import { type ReactNode, useEffect, useState } from "react";

import { formatCooldown, remainingSeconds } from "@/lib/code-cooldown";
import { markCodeSent, readCodeSentAt } from "@/lib/code-sent";

import { TextButton } from "./text-link";

export const ResendRow = ({
  alternate,
  flow,
  onResend,
}: {
  alternate: ReactNode;
  flow: string;
  onResend: () => Promise<void>;
}) => {
  const [now, setNow] = useState(() => Date.now());
  const [pending, setPending] = useState(false);

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 250);
    return () => window.clearInterval(timer);
  }, []);

  const sentAt = readCodeSentAt(flow) ?? now;
  const remaining = remainingSeconds(sentAt, now);

  return (
    <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-2 border-n-200 border-t pt-6 text-[15px] text-n-600">
      {remaining > 0 ? (
        <span aria-live="polite" className="tabular-nums">
          Resend code in {formatCooldown(remaining)}
        </span>
      ) : (
        <TextButton
          disabled={pending}
          onClick={() => {
            setPending(true);
            onResend()
              .then(() => markCodeSent(flow))
              .finally(() => setPending(false));
          }}
        >
          Resend code
        </TextButton>
      )}
      {alternate}
    </div>
  );
};
